import clsx from "clsx";
import LCountDownTimer from "../lcount-down-timer/LCountDownTimer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import ReactMarkdown from "react-markdown";
import { FC } from "react";
import WButton from "../wbutton/WButton";
import router from "next/router";
import parse from "html-react-parser";
import { babelIncludeRegexes } from "next/dist/build/webpack-config";

/* eslint-disable-next-line */
interface IDarkVersusContentLeftRightItem {
  id?: string;
  title?: string;
  content?: string;
  iconName?: string;
}

interface IDarkVersusContentItem {
  id?: string;
  title?: string;
  leftItem?: IDarkVersusContentLeftRightItem;
  rightItem?: IDarkVersusContentLeftRightItem;
}

export interface LDarkVersusContentProps {
  id?: string | null;
  darkVersusContentMainTitle?: string | null;
  darkVersusContentTitle?: string | null;
  subtitle?: string | null;
  countDownTimer?: {
    id?: string | null;
    endDate?: string | null;
    description?: string | null;
  };
  bottomImage?: string | null;
  darkVersusContentItems?: IDarkVersusContentItem[];
  button?: {
    text: string | null;
    url: string | null;
  };
}

export const LDarkVersusContent: FC<LDarkVersusContentProps> = ({
  darkVersusContentMainTitle,
  darkVersusContentTitle,
  subtitle,
  countDownTimer,
  bottomImage,
  darkVersusContentItems,
  button,
}) => {
  return (
    <div className="py-20 bg-ekblue">
      <div className="container flex flex-col items-center justify-center gap-10 px-4 mx-auto mt-10 text-center text-white lg:max-w-7xl">
        <h1 className="text-white">{darkVersusContentMainTitle}</h1>
        {darkVersusContentItems?.map((item, idx) => (
          <div key={idx} className="flex flex-col w-full gap-4">
            <h3 className="text-white">{item?.title}</h3>
            <div className="flex flex-col lg:flex-row">
              <div className="container flex flex-col gap-4 p-4 bg-white rounded-md lg:w-1/2">
                <FontAwesomeIcon
                  icon={item?.leftItem?.iconName as IconName}
                  className="text-ekred"
                  size="xl"
                />
                <h3 className="text-black">{item?.leftItem?.title}</h3>
                {item?.leftItem?.content && (
                  <ReactMarkdown
                    // disable es-lint because react-markedown decided its a "good" idea to call the prop "children"
                    // eslint-disable-next-line react/no-children-prop
                    children={item?.leftItem?.content}
                  />
                )}
              </div>
              <div className="z-50 self-center px-4 py-3 -my-2 font-bold rounded-full lg:-mx-2 lg:my-0 bg-[#E6361C]">
                VS
              </div>
              <div className="container flex flex-col gap-4 p-4 bg-white rounded-md lg:w-1/2">
                <FontAwesomeIcon
                  icon={item?.rightItem?.iconName as IconName}
                  className="text-ekgreen"
                  size="xl"
                />
                <h3 className="text-black">{item?.rightItem?.title}</h3>
                {item?.rightItem?.content && (
                  <ReactMarkdown
                    // disable es-lint because react-markedown decided its a "good" idea to call the prop "children"
                    // eslint-disable-next-line react/no-children-prop
                    children={item?.rightItem?.content}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div
        className={clsx([
          "text-center justify-center items-center container flex flex-col gap-10 px-4 mx-auto mt-10 text-white lg:max-w-7xl",
        ])}
      >
        {bottomImage && (
          <img src={bottomImage} alt="" className="mx-auto w-fit" />
        )}
        <h1 className="text-white">{parse(darkVersusContentTitle ?? "")}</h1>
        <div className={clsx(["mx-auto", "max-w-4xl white-markdown"])}>
          {subtitle}
        </div>
        {countDownTimer && countDownTimer?.endDate && (
          <div className="flex flex-col items-center justify-center gap-4 text-center">
            <LCountDownTimer endDate={new Date(countDownTimer?.endDate)} />
            <div className="max-w-xl">{countDownTimer?.description}</div>
          </div>
        )}
        {button && (
          <WButton
            text={button?.text || ""}
            type="primary-red-btn"
            className="mx-auto w-fit lg:mx-0"
            onClick={() => {
              button?.url && router.push(button.url);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default LDarkVersusContent;
